import * as React from 'react';

const InfoIcon = (props) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    id='BeBold'
    width={'1em'}
    height={'1em'}
    viewBox='0 0 14 14'
    {...props}
  >
    <defs>
      <style>{'.cls-1{fill:currentColor}'}</style>
    </defs>
    <g id='Info'>
      <circle cx={6.834} cy={2.188} r={2.188} className='cls-1' />
      <path
        d='M9.35 12.25a.657.657 0 0 1-.657-.656v-5a.656.656 0 0 0-.656-.656H4.649a.656.656 0 0 0-.656.656v.438a.656.656 0 0 0 .656.656.656.656 0 0 1 .656.656v3.255a.656.656 0 0 1-.656.656.656.656 0 0 0-.656.656v.438a.656.656 0 0 0 .656.651h4.7a.656.656 0 0 0 .656-.656v-.438a.656.656 0 0 0-.655-.656Z'
        className='cls-1'
      />
    </g>
  </svg>
);
export default InfoIcon;
